import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import settings from 'settings';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';
import ExtendedSelect from 'components/extendedSelect';

const mapStateToProps = (state, ownProps) => ({
  inFlight: state.api[ownProps.tagSelectorReducerKey.key].inFlight,
  collectionValues: state.api[ownProps.tagSelectorReducerKey.key].data.results,
  themes: state.api.themes.data.results
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadTagCollection(filters) {
    const sorted = ownProps.sorting ? ownProps.sorting : [];

    return dispatch(list([ownProps.tagSelectorReducerKey.key], {
      page: 0,
      pageSize: settings.APP_CONFIG.dropListSize,
      filters,
      sorted
    }));
  },
  loadThemes(theme) {
    return dispatch(list(
      REDUCER_KEY.themes.key,
      {
        page: 0,
        pageSize: settings.APP_CONFIG.dropListSize,
        filters: [{
          id: 'model',
          value: theme
        }],
        sorted: [{
          id: 'model',
          desc: false
        }]
      }
    ));
  }
});

const tagOptionKey = item => item.id;
const tagOptionLabel = item => item.qualified_name;

class TagSelector extends Component {
  constructor(props) {
    super(props);

    this.handleTagChange = this.handleTagChange.bind(this);
    this.handleTagChange = debounce(this.handleTagChange, 100);

    this.loadTags = this.loadTags.bind(this);
  }

  componentDidMount() {
    this.loadTags();
  }

  loadTags(searchText = '') {
    const { theme, loadThemes, loadTagCollection } = this.props;

    loadThemes(theme)
      .then((response) => {
        if (response && response.results.length) {
          const { id } = response.results[0];
          // ------ Set query the Filters ------
          const filters = [{
            id: 'collection__theme',
            value: id
          }];
          if (searchText) {
            filters.push({
              id: 'q',
              value: searchText
            }); // query the server query fields for a broad search
          }

          // ------ Load the Tags ------
          loadTagCollection(filters);
        }
      });
  }

  handleTagChange(value) {
    const { onChange } = this.props;
    // ------ Return the selected Tag Ids ------
    onChange(value);
  }

  render() {
    const {
      collectionValues, inFlight, disabled, showSearch, dropdownMatchSelectWidth, placeholder, value, size, mode, maxTagCount, themes, labelInValue
    } = this.props;

    if (!themes.length) {
      return null;
    }

    return (
      <div>
        <ExtendedSelect
          placeholder={placeholder}
          value={value}
          size={size}
          mode={mode}
          maxTagCount={maxTagCount}
          dataSource={collectionValues}
          optionKey={tagOptionKey}
          optionLabel={tagOptionLabel}
          onSearch={this.loadTags}
          onFocus={this.loadTags}
          onChange={this.handleTagChange}
          showSearch={showSearch}
          dropdownMatchSelectWidth={dropdownMatchSelectWidth}
          disabled={disabled}
          fetching={inFlight}
          labelInValue={labelInValue}
        />
        <span style={{ fontSize: '11px', color: '#888', fontStyle: 'italic' }}>** = Used by Optimiser</span>
      </div>
    );
  }
}

TagSelector.propTypes = {
  collectionValues: PropTypes.array,
  loadTagCollection: PropTypes.func.isRequired,
  loadThemes: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  size: PropTypes.string,
  mode: PropTypes.string,
  maxTagCount: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  inFlight: PropTypes.bool,
  showSearch: PropTypes.bool,
  dropdownMatchSelectWidth: PropTypes.bool,
  themes: PropTypes.array,
  labelInValue: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  sorting: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.string, PropTypes.string)
  )
};

TagSelector.defaultProps = {
  collectionValues: [],
  placeholder: 'Select Tag',
  size: 'default',
  mode: 'multiple',
  maxTagCount: 3,
  showSearch: true,
  dropdownMatchSelectWidth: true,
  value: [],
  onChange() {
  },
  disabled: false,
  inFlight: false,
  themes: [],
  labelInValue: true,
  sorting: []
};

export default connect(mapStateToProps, mapDispatchToProps)(TagSelector);
